module.exports = __webpack_public_path__ + "img/bg.53999b95.jpg";